// extracted by mini-css-extract-plugin
export default {"name":"feature_name__p22e+","description":"feature_description__f4kXX","image":"feature_image__vxIQZ","featurecontainer":"feature_featurecontainer__9enin"};